import { ComponentInterface } from '../component-interface';
import domEvtHandler from '../dom-event';
import { createElement, hashify, extend2, isIE, hasSVG, rgbaToHex, hasTouch } from '../lib';

const ENTER_CODE = 13,
  ESCAPE_CODE = 27;

let linkedAxis;

function getCharCode (e) {
  return (typeof e.which === 'number') ? e.which : e.keyCode;
}

function onMouseUp (e) {
  var ele = e.target;
  if (ele.justFocussed) {
    ele.justFocussed = false;
    if (!hasTouch) {
      ele.select();
    }
  }
}

function doAxisUpdate (value, oldvalue, isMax) {
  var success = false,
    axisParent = this.config.linkedAxis.getLinkedParent();
  // do not update if value has not changed
  if (value === oldvalue + '') {
    return;
  }

  if (isMax) {
    success = axisParent.changeUpperLimits && axisParent.changeUpperLimits(Number(value));
  } else {
    success = axisParent.changeLowerLimits && axisParent.changeLowerLimits(Number(value));
  }

  // if (!success && showRangeError) {
  //   chart.showMessage('Sorry! Not enough range gap to modify axis limit to ' +
  //     (Number(value) || '0') +
  //     '.<br />Please modify the data values to be within range.<br />&nbsp;<br />' +
  //     '(click anywhere on the chart to close this message)', true);
  // }

  return success;
}

function onFocus (e) {
  var ele = e.target,
    styleObj = {
      opacity: 1,
      filter: 'alpha(opacity=100)', // IE opacity
      color: rgbaToHex(ele.axisLabel.attr('fill'))
    },
    item;

  for (item in styleObj) {
    ele.style[item] = styleObj[item];
  }

  ele.value = ele.dataValue;

  ele.justFocussed = true;
  // for IE
  ele.hasFocus = true;
  ele.axisLabel && ele.axisLabel.hide();
  // if (!chart.graphics.hiddenAxisLabels) {
  //   chart.graphics.hiddenAxisLabels = [];
  // }
  // chart.graphics.hiddenAxisLabels.push(ele.axisLabel);
}

function onBlur (e) {
  var ele = e.target,
    newValue = ele.value,
    oldValue = ele.oldValue,
    isMaxLabel = ele.isMaxLabel;
    // success = doAxisUpdate(newValue, oldValue, isMaxLabel);

  doAxisUpdate.call(this, newValue, oldValue, isMaxLabel);
  // if (success !== true) {
  ele.style.opacity = 0;
  ele.style.filter = 'alpha(opacity=0)';
  // IE opacity
  ele.axisLabel && ele.axisLabel.show();
  // }

  if (isIE) {
    // To call the actual blur on the element in case of IE
    document.getElementsByTagName('body')[0].focus &&
    document.getElementsByTagName('body')[0].focus();
  }

  ele.justFocussed = false;
  ele.hasFocus = false;
}

function onKeyUp (e) {
  var ele = e.target,
    keyCode = getCharCode(e.originalEvent),
    newValue = ele.value,
    oldValue = ele.oldValue,
    isMaxLabel = ele.isMaxLabel,
    success;

  if (keyCode === ENTER_CODE) {
    success = doAxisUpdate.call(this, newValue, oldValue, isMaxLabel);
    if (success === false) {
      ele.style.color = '#dd0000';
    } else {
      domEvtHandler.fire(ele, 'blur', e);
    }
  } else if (keyCode === ESCAPE_CODE) {
    ele.value = oldValue;
    domEvtHandler.fire(ele, 'blur', e);
  }
}

function defaultHandler (inputElement) {
  return function (e) {
    if (inputElement.parentNode) {
      domEvtHandler.fire(inputElement, 'blur', e);
    }
  };
}

function defaultIEHandler (inputElement) {
  return function (e) {
    if (e.target !== inputElement && inputElement.hasFocus) {
      domEvtHandler.fire(inputElement, 'blur', e);
    }
  };
}

function destroyHandler (inputElement, defaultAction) {
  domEvtHandler.unlisten(this.config.linkedAxis.getLinkedParent(), 'defaultprevented', defaultAction);
  inputElement.parentNode.removeChild(inputElement);
}

function destroyIEHandler (inputElement, defaultAction) {
  return function () {
    domEvtHandler.unlisten(linkedAxis.getLinkedParent().getLinkedItem('container'), 'mousedown', defaultAction);
    inputElement.parentNode.removeChild(inputElement);
  };
}

class LimitUpdater extends ComponentInterface {
  configureAttributes () {
    this.config.linkedAxis = this.getLinkedParent();
    linkedAxis = this.config.linkedAxis;
    this.config.onKeyUp = onKeyUp.bind(this);
    this.config.onBlur = onBlur.bind(this);
    this.config.onFocus = onFocus.bind(this);
    this.config.onMouseUp = onMouseUp.bind(this);
  }
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'helper';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'limitUpdater';
  }

  draw () {
    // draw this component;
    let limitUpdater = this,
      chartConf = limitUpdater.getFromEnv('chartConfig'),
      axis = limitUpdater.config.linkedAxis,
      extremeLabels = axis.getAxisConfig('extremeLabels'),
      axisLimits = axis.getLimit(),
      chartContainer = limitUpdater.getFromEnv('chart-container'),
      chartCanvasStyle = limitUpdater.getFromEnv('style').inCanvasStyle,
      inputStyle = extend2({
        outline: 'none', // prevent chrome outlining
        '-webkit-appearance': 'none', // disable ios background
        filter: 'alpha(opacity=0)', // IE opacity
        position: 'absolute',
        background: 'transparent',
        border: '1px solid #cccccc',
        textAlign: 'right',
        top: 0,
        left: 0,
        width: 50,
        zIndex: 20,
        opacity: 0,
        borderRadius: 0,
        display: 'block'
      }, chartCanvasStyle),
      labelObj = {
        max: {
          element: extremeLabels.lastLabel.graphic,
          value: axisLimits.max
        },
        min: {
          element: extremeLabels.firstLabel.graphic,
          value: axisLimits.min
        }
      },
      inputElement,
      inputElementName,
      labelElement,
      key,
      styleKey,
      labelBox,
      isMaxLabel,
      labelValue,
      closedDefaultHandler,
      inputWidth,
      inputLeft,
      closedDefaultIEHandler;

    inputStyle.color = hashify(inputStyle.color);
    inputStyle.fontSize = `${inputStyle.fontSize}px`;

    for (key in labelObj) {
      if (labelObj.hasOwnProperty(key)) {
        labelElement = labelObj[key].element;
        labelBox = labelElement && labelElement.getBBox();
        labelValue = labelObj[key].value;
        isMaxLabel = (key === 'max');

        inputElementName = `${key}Input`;
        inputElement = limitUpdater.getGraphicalElement(inputElementName);
        if (!(labelBox && labelElement)) {
          if (inputElement) {
            inputElement.style.display = 'none';
          }
          continue;
        }
        if (!inputElement) {
          inputElement = limitUpdater.addGraphicalElement(inputElementName, createElement('input', {
            type: 'text',
            value: labelValue,
            id: `fc-updater-${key}`
          }, chartContainer));
        }

        // Add events to make the textboxes visible on focus and hide when not.
        domEvtHandler.listen(inputElement, ['focus', 'mouseup', 'blur', 'keyup'], [this.config.onFocus, this.config.onMouseUp, this.config.onBlur, this.config.onKeyUp]);

        if (hasSVG) {
          domEvtHandler.listen(chartContainer, 'defaultprevented', closedDefaultHandler = defaultHandler(inputElement));
          // cleanup handlers
          domEvtHandler.listen(chartContainer, 'destroy', destroyHandler.bind(this, inputElement, closedDefaultHandler));
        } else {
          domEvtHandler.listen(chartContainer, 'mousedown', closedDefaultIEHandler = defaultIEHandler(inputElement));
          // cleanup handlers
          domEvtHandler.listen(chartContainer, 'destroy', destroyIEHandler(inputElement, closedDefaultIEHandler));
        }

        inputWidth = labelBox.x + labelBox.width - chartConf.marginLeft;
        inputLeft = chartConf.marginLeft;

        inputStyle.top = `${labelBox.y}px`;
        inputStyle.left = `${inputLeft}px`;
        inputStyle.width = `${inputWidth}px`;

        for (styleKey in inputStyle) {
          if (inputStyle.hasOwnProperty(styleKey)) {
            inputElement.style[styleKey] = inputStyle[styleKey];
          }
        }

        inputElement.dataValue = labelValue;
        inputElement.value = labelValue;
        inputElement.oldValue = labelValue;
        inputElement.name = labelValue || '';
        inputElement.axisLabel = labelElement;
        inputElement.isMaxLabel = isMaxLabel;
      }
    }
  }

  /**
   * Generalised function for removing an entire instance of a component
   */
  removingDraw () {
    let graphics = this.getGraphicalElement(),
      key,
      element;
    for (key in graphics) {
      if (graphics.hasOwnProperty(key)) {
        element = graphics[key];
        element && element.parentNode && element.parentNode.removeChild(element);
        delete graphics[key];
      }
    }
  }
}

export default LimitUpdater;
